/*
    This is a basic field validation fuinction that uses parts of the already existing validation manager.
    It feels a bit of a hack, but is basic and good for the current stage.
   */
import { ValidationManager } from '@chegg/commerce-utils';
import { UPIFIELDS, PINCODE_LENGTH, NAME_LENGTH } from './types';
var VALIDATION_TYPES = ValidationManager.types.VALIDATION_TYPES;
export function isValidForm(formValues, setFieldCB) {
  var result = true;
  var error = ValidationManager.validateField({
    fieldName: UPIFIELDS.NAME,
    value: formValues.name.value,
    validations: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.ALPHA]
  }).error !== '';
  if (!error) {
    if (formValues.name.value.length > NAME_LENGTH) {
      error = true;
    }
  }
  result = !error;
  setFieldCB(UPIFIELDS.NAME, {
    error: error
  });
  error = ValidationManager.validateField({
    fieldName: UPIFIELDS.PINCODE,
    value: formValues.pincode.value,
    validations: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.NUMERIC]
  }).error !== '';
  if (!error) {
    if (formValues.pincode.value.length !== PINCODE_LENGTH) {
      error = true;
    }
  }
  setFieldCB(UPIFIELDS.PINCODE, {
    error: error
  });
  result = result && !error;
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/isValidUpiForm.js
// module id = 4593
// module chunks = 11